import { render, staticRenderFns } from "./TooltipEvent.vue?vue&type=template&id=dde8983a"
import script from "./TooltipEvent.vue?vue&type=script&lang=js"
export * from "./TooltipEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports